import React from 'react';

import { makeStyles } from '@mui/styles';
import { useFormContext } from 'react-hook-form';

import { withShowable } from '../../../console/_global/lib/withShowable';
import { Button } from '../../../components/Buttons/Button';

export const EditSection = withShowable(() => {
  const methods = useFormContext();
  const classes = useEditSectionStyles();
  const { isDirty } = methods.formState;

  const onCancelBtnClick = () => {
    const confirmCancel = window.confirm(
      'You have unsaved changes, are you sure you want to cancel?'
    );

    if (confirmCancel) {
      methods.reset();
    }
  };

  return (
    <div className={classes.editSection}>
      {/* @ts-expect-error: FIXME */}
      <Button
        disabled={!isDirty}
        onClick={onCancelBtnClick}
        variant="outlined"
        fixed
        size="sm"
      >
        Cancel
      </Button>
      {/* @ts-expect-error: FIXME */}
      <Button
        type="submit"
        disabled={!isDirty || !!methods.formState.errors.domainName}
        stylename="primary"
        fixed
        size="sm"
      >
        Save
      </Button>
    </div>
  );
});

const useEditSectionStyles = makeStyles(({ spacing }) => ({
  editSection: {
    display: 'flex',
    justifyContent: 'center',
    marginTop: '2rem',

    '& > *': {
      marginLeft: spacing(1),
    },
  },
}));
